export enum ImageType {
  Banner = "BANNER",
  ScreenBanner = "SCREEN_BANNER",
  Image = "IMAGE",
}
